export const Operator = {
  OR: '|',
  AND: '&',
  OPEN_PARENTHESES: '(',
  CLOSE_PARENTHESES: ')',
};

export const operators = [Operator.AND, Operator.OR];
